// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { Target } from '../../../../client';
import CopyButton from '../../../../components/CopyButton';
import FacebookButton from '../../../../components/FacebookButton';
import TwitterButton from '../../../../components/TwitterButton';
import config from '../../../../config/app.config';
import { __, getLang } from '../../../../i18n/l10n';

const Wrap = styled.div``;

const WrapBtns = styled.div`
  margin: 1em ${Target.__MOBILE__ ? 0 : '0.6em'} 0;

  display: flex;
  align-items: center;
  justify-content: space-between;

  > * {
    &:not(:last-child) {
      margin-right: 0.5em;
    }
  }
`;

const StyledCopyButton = styled(CopyButton)`
  flex: 1;
`;

const Facebook = styled(FacebookButton)`
  flex: 1;

  > button {
    width: 100%;
  }
`;

const Twitter = styled(TwitterButton)`
  flex: 1;

  > button {
    width: 100%;
  }
`;

type Props = {
  className?: string;
  gridReference: string;
  children?: React.ReactNode;
};

const ShareGrid = ({ className, gridReference, children }: Props) => {
  const shareUrl = `${config.sharingGridUrl[getLang()]}/${gridReference}`;
  const shareText = `${__('Winamax grid')} ${shareUrl}`;

  return (
    <>
      {children ? <Wrap className={className}>{children}</Wrap> : null}
      <WrapBtns>
        <StyledCopyButton text={shareUrl}>{__('Copy the link')}</StyledCopyButton>
        <Facebook url={shareUrl} />
        <Twitter text={shareText} />
      </WrapBtns>
    </>
  );
};

export default ShareGrid;
